(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-main-product"]) return;
  try {
    
if (!customElements.get('sl-gallery')) {
  class SlGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sl-gal__track');
      this.dots = [...this.querySelectorAll('.sl-gal__dot')];
      this.thumbs = [...this.querySelectorAll('.sl-gal__thumb')];
      this.lb = this.querySelector('.sl-gal__lightbox');
      this.slides = [...this.track.children];
      this.addEventListener('click', (e) => {
        const go = e.target.closest('[data-go]');
        if (go) { this.goTo(parseInt(go.dataset.go, 10)); return; }
        const zoom = e.target.closest('[data-zoom]');
        if (zoom && this.lb) { this.openLightbox(parseInt(zoom.dataset.zoom, 10)); return; }
        if (e.target.closest('[data-close]') || e.target === this.lb) this.lb.close();
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
      });
      this.index = 0;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) this.setActive(parseInt(en.target.dataset.index, 10)); });
      }, { root: this.track, threshold: [0.6] });
      this.slides.forEach((s) => { if (s.dataset.index !== undefined) io.observe(s); });
    }
    goTo(i) {
      const n = Math.max(0, Math.min(this.slides.length - 1, i));
      const s = this.slides[n];
      if (s) this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.setActive(n);
    }
    setActive(i) {
      this.index = i;
      this.dots.forEach((d, k) => d.setAttribute('aria-selected', String(k === i)));
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    }
    openLightbox(i) {
      const imgs = [...this.lb.querySelectorAll('img[data-src]')];
      imgs.forEach((img) => { if (!img.src) img.src = img.dataset.src; });
      this.lb.showModal();
      const target = this.lb.querySelectorAll('.sl-gal__lb-slide')[i];
      if (target) target.scrollIntoView({ block: 'nearest', inline: 'start' });
    }
  }
  customElements.define('sl-gallery', SlGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-ugc-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-ugc')) {
  class SlUgc extends HTMLElement {
    connectedCallback() {
      const c = navigator.connection;
      this.lite = !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
      this.frames = [...this.querySelectorAll('[data-ugc-frame]')];
      if (!this.frames.length || !('IntersectionObserver' in window)) return;
      this.loader = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { this.hydrate(e.target); this.loader.unobserve(e.target); } });
      }, { rootMargin: '200px 200px' });
      this.player = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target.querySelector('video');
          if (!v) return;
          if (e.intersectionRatio >= 0.6) { v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: [0, 0.6, 1] });
      this.frames.forEach((f) => {
        if (!this.lite) this.loader.observe(f);
        this.player.observe(f);
        f.addEventListener('click', () => this.toggleSound(f));
      });
    }
    disconnectedCallback() {
      if (this.loader) this.loader.disconnect();
      if (this.player) this.player.disconnect();
    }
    hydrate(frame) {
      const tpl = frame.querySelector('template[data-ugc-src]');
      if (!tpl || frame.querySelector('video')) return;
      const poster = frame.querySelector('.ugc-card__poster');
      frame.insertBefore(tpl.content.cloneNode(true), tpl);
      const v = frame.querySelector('video');
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.removeAttribute('controls');
      if (poster) v.poster = poster.currentSrc || poster.src;
      v.addEventListener('playing', () => frame.classList.add('is-playing'), { once: true });
    }
    toggleSound(frame) {
      if (!frame.querySelector('video')) this.hydrate(frame);
      const v = frame.querySelector('video');
      const btn = frame.querySelector('.ugc-card__sound');
      if (!v || !btn) return;
      this.querySelectorAll('video').forEach((o) => { if (o !== v) { o.muted = true; const b = o.parentElement.querySelector('.ugc-card__sound'); if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', b.dataset.on); } } });
      v.muted = !v.muted;
      if (v.paused) v.play().catch(() => {});
      btn.setAttribute('aria-pressed', String(!v.muted));
      btn.setAttribute('aria-label', v.muted ? btn.dataset.on : btn.dataset.off);
    }
  }
  customElements.define('sl-ugc', SlUgc);
}

  } catch(e) { console.error(e); }
})();
})();
